const translation = {
  general: {
    minute_one: '{{ count }} minute',
    minute_other: '{{ count }} minutes',
    hour_one: '{{ count }} hour',
    hour_other: '{{ count }} hours',
  },
  app: {
    exit: 'Exit',
    close: 'Close',
    footer: 'Powered by One Click Go Live Limited',
    'login-btn': 'Log In',
    'logout-btn': 'Log Out',
    confirm: 'Confirm',
  },
  login: {
    title: 'User Login',
    'email-label': 'Enter Email',
    'not-registered-remark':
      "If not registered yet, please enter your email address and click the 'Confirm' button below",
    'otp-guide-title': 'OTP Sent',
    'otp-label': 'Enter Your OTP',
    'otp-remark-1': 'We have sent your OTP to the following email address',
    'otp-remark-2': 'Please complete the login process within 15 minutes',
    'next-step': 'Next Step',
    'email-error': 'Incorrect email, please login again',
    'unknown-error': 'Error, please login again',
    'otp-error': 'Incorrect OTP, please login again',
    'otp-fatal-error': 'OTP timeout or OTP was incorrect for more than 3 times, please login again',
  },
  home: {
    title: 'home',
  },
  event: {
    info: 'Info',
    'q-and-a': 'Q&A',
    question: {
      placeholder: 'There will be a Q&A session. Please submit your question here.',
      submit: 'Submit',
      'succeed-message': 'Thank you for submitting your question',
      'failed-message': 'Submission failed, please try again later',
      'exceeds-char-limit-message': 'You can enter up to 200 characters',
    },
    chatroom: 'Chatroom',
    polling: 'Polling',
    si: {
      english: 'eng',
      cantonese: 'can',
      putonghua: 'pth',
    },
    playback: {
      'error-title': 'Video playback failure.',
      'error-message':
        'Either your network environment is unstable or you are not authorized to access this video.',
    },
    'just-started': 'Just started',
    'started-ago': 'Started {{age}} ago',
    'concurrent-error-message': 'Your account is logged in on another device',
    'connection-error-message': 'Network not stable',
    'require-login-message': "Log in if you've been granted access to this event",
    'session-kicked-error-message':
      'Your account is logged in on another device, click below button to view on this device',
    'view-here': 'View Here',
    unauthorized: 'Unauthorized to view',
  },
  passcode: {
    label: 'Please input your passcode:',
    enter: 'Enter',
    remark: 'Please contact event organiser if you have not received your passcode yet',
    error: 'Incorrect Passcode',
    'select-placeholder': 'Please Select',
  },
  registration: {
    title: 'THE JOURNEY TO PEACE & PROSPERITY\nTHROUGH DIALOGUE',
    'intro-1':
      'The International Organization for Mediation (IOMed) is the world’s first treaty-based inter-governmental organization dedicated to resolving international disputes through mediation and with its Headquarters located in the Hong Kong SAR, China.',
    'intro-2':
      'In this inaugural IOMed Global Series, Mr. Paul Lam SC and Mr. Rimsky Yuen SC, Secretaries for Justice of Hong Kong SAR at the relevant times, will share untold stories and background to the development of policies and legislations promulgated in support of mediation over the years, including the support to the establishment of IOMed. Hong Kong SAR has taken a journey that demonstrates how mediation, as one of its core attributes, can provide a viable and realistic alternative to peaceful settlement of disputes, contributing to peace and prosperity in this challenging world.',
    'event-details': 'Event Details',
    'date-key': 'Date',
    'time-key': 'Time',
    'venue-key': 'Venue',
    'address-key': 'Address',
    'language-key': 'Language',
    'agenda-key': 'Agenda',
    'speakers-key': 'Speakers',
    'format-key': 'Format',
    date: '24 September 2026 (Thursday)',
    time: '6:00 pm for 6:30 pm to 7:30 pm (Hong Kong SAR time)',
    'time-1': '9:30am - 12:40pm (Registration starts at 9am)',
    'time-2': '12:40pm – 2:30pm (Networking Lunch)',
    venue: 'International Organization for Mediation (IOMed) Headquarters',
    address: 'No. 123 Gloucester Road, Wan Chai, Hong Kong (Old Wan Chai police station)',
    'address-2': 'In-person participants are advised to use the entrance at 188 Jaffe Road.',
    language: 'English or Mandarin (With real-time AI screen translation)',
    agenda: 'Click <0>HERE</0> to view details',
    speakers: 'Click <0>HERE</0> to view details',
    'virtual-date': '4 March 2025 (Tuesday)',
    'virtual-time': '10:00 am - 12:30 pm (HKT)',
    'virtual-format': 'Online',
    'form-heading': 'Registration',
    'form-attendance-type': 'Attendance Type',
    'attendance-physical': 'In-person',
    'attendance-online': 'Online',
    'form-title': 'Title',
    'form-first-name': 'First / Given Name',
    'form-last-name': 'Last Name / Surname',
    'form-job-title': 'Job Title',
    'form-company': 'Company / Organization',
    'form-email': 'Email',
    'form-membership-number':
      'Membership Number for Members of The Law Society of Hong Kong (if applicable)',
    'form-jurisdiction': 'Jurisdiction',
    'form-agree-pics':
      'I have read and agree to the <0>Personal Information Collection Statement</0>.',
    'form-agree-photo':
      'I have read and agree to the <0>Statement on Use of Event Photos and/or Videos</0>.',
    'form-agree-terms':
      'I have read and agree to the <0>Terms and Conditions</0> set out above by the organiser and declare that the information above is correct. I acknowledge that the personal information as provided will be the point of contact for the organiser.',
    'form-agree-marketing':
      "I agree to subscribe to IOMed's email list and consent to receive updates, news, and other marketing communications from IOMed. I also consent to the use of my personal data for marketing purposes by selected third-party partners.",
    copyright: 'Copyright © International Organization for Mediation, All Rights Reserved',
    'pics-url': 'https://event.oneclickgolive.com/external/iomed/20260924/pics-en.pdf',
    'photo-url':
      'https://event.oneclickgolive.com/external/iomed/20260924/statement-of-use-photo-en.pdf',
    'terms-url': 'https://event.oneclickgolive.com/external/iomed/20260924/tnc-en.pdf',
    'data-protection-email': 'Data-protection@investhk.gov.hk',
    submit: 'Submit',
    'submit-succeed': 'Submit Succeed',
    'submit-failed': 'Submit Failed',
    'submit-failed-email': 'Submit Failed\nThis email address is already registered',
    'please-select': 'Please select',
    'title-prof': 'Prof',
    'title-dr': 'Dr',
    'title-mr': 'Mr',
    'title-mrs': 'Mrs',
    'title-ms': 'Ms',
    'title-miss': 'Miss',
    'title-others': 'Others',
    'error-attendance-type': 'Please select your attendance type',
    'error-title': 'Please select your title',
    'error-email': 'Please enter your email address',
    'error-first-name': 'Please enter your first name',
    'error-last-name': 'Please enter your last name',
    'error-company': 'Please enter your company',
    'error-jurisdiction': 'Please select your jurisdiction',
    'error-agree-pics': 'Please accept the Personal Information Collection Statement',
    'error-agree-photo': 'Please accept the Statement on Use of Event Photos and/or Videos',
    'error-agree-terms': 'Please accept the Terms and Conditions',
  },
};

export default translation;
